

export const enlargePayload = (action, data) => ({...action, payload: {...action.payload, ...data}});
export const replacePayload = (action, data) => ({...action, payload: data});

export const addOptions = (action, data) => ({...action, options: Array.isArray(data) ? data : {...action.options, ...data}});
export const replaceType = (action, newType) => ({...action, type: newType});
